import { createSelector } from "@reduxjs/toolkit";
import { StoreState } from "../../store";

const selector = (state: StoreState) => state.coupon;

export const couponSelectors = {
  coupons: createSelector(selector, (state) => state.coupons),
  couponExternals: createSelector(selector, (state) => state.couponExternals),
  appliedCoupons: createSelector(selector, (state) => state.appliedCoupons),
  appCoupons: createSelector(selector, (state) => state.appCoupons),
  unselectedAppCoupons: createSelector(
    selector,
    (state) => state.unselectedAppCoupons,
  ),
  selectedAppCoupons: createSelector(
    selector,
    (state) => state.selectedAppCoupons,
  ),
  remainingSlot: createSelector(selector, (state) => state.remainingSlot),
};
